<template>
  <div class="s_system_config_base g-flex-column" v-show="show">
    <el-form ref="form" :model="form" label-width="200px" label-position="right">
      <el-row :gutter="20">
        <el-col :span="20">
          <el-form-item label="验证码">
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 5}" v-model="form.yzm"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="20">
          <el-form-item label="充值到账">
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 5}" v-model="form.czdz"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="20">
          <el-form-item label="任务驳回">
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6}" v-model="form.rwbh"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="20">
          <el-form-item label="任务接取">
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6}" v-model="form.task"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="20">
          <el-form-item label="任务审核通过">
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6}" v-model="form.task_tg"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="20">
          <el-form-item label="账号审核通过">
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6}" v-model="form.zhsh"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="20">
          <el-form-item label="追评任务">
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6}" v-model="form.zprw"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <el-button type="primary" size="large" @click="submitClick">确定修改</el-button>
      </el-form-item>
    </el-form>

    
  </div>
</template>

<script>
import { apiGetSystemConfig, apiSetSystemConfig } from '@/utils/api.js'
  export default {
    data() {
      return {
        msg: 'Welcome to Use Tinymce Editor',
        code: '',
        show: false,
        form: {
          yzm: "", //验证码
          czdz: "",  //充值到账
          rwbh: "", //任务驳回
          task: "", //任务接取
          task_tg: "", //任务审核通过
          zhsh: "", //账号审核通过
          zprw: "", //追评任务
        }
      }
    },
    methods: {
      //鼠标单击的事件
      onClick(e, editor) {
        console.log('Element clicked')
        console.log(e)
        console.log(editor)
      },
      //清空内容
      clear() {
        this.$refs.editor.clear()
      },
      onShow(code) {
        this.code = code
        this.show = true
        this.apiGetSystemConfigHandel()
      },


 

      async apiGetSystemConfigHandel() {
        let loading = this.$loading()
        const { success, data } = await apiGetSystemConfig({ code: this.code}).catch(() => loading.close())
        loading.close()
        if(!success) return
        this.form = data.data
        console.log(data)
      },

      async submitClick() {
        let loading = this.$loading()
        const { success, data } = await apiSetSystemConfig({ code: this.code, config: this.form }).catch(() => loading.close())
        loading.close()
        if(!success) return
        this.$message.success(data.msg)
      },
    }

  }
</script>

<style lang="scss">
.s_system_config_base {
  .s-system-config-base-btn {
    padding-top: 30px;
  }
}
</style>